import {FC} from 'react'
import ApplicationResponsiveModal from '../common/ApplicationResponsiveModal'

type HelperLink = {
  label: string
  sublabel: string
  href: string
  icon: React.ReactElement
  iconVariantClassName: string
}

type DooraHelperModalProps = {
  onClose: () => void
}

const helperLinks: HelperLink[] = [
  {
    label: 'Message us on Instagram',
    sublabel: '@doora',
    href: 'https://instagram.com/direct/t/doora',
    iconVariantClassName: 'application-helper-option-icon-instagram',
    icon: (
      <svg width='22' height='22' viewBox='0 0 24 24' fill='none' aria-hidden='true'>
        <rect
          x='3'
          y='3'
          width='18'
          height='18'
          rx='5'
          stroke='currentColor'
          strokeWidth='1.8'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <circle
          cx='12'
          cy='12'
          r='4'
          stroke='currentColor'
          strokeWidth='1.8'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <circle cx='17.5' cy='6.5' r='0.6' fill='currentColor' />
      </svg>
    ),
  },
  {
    label: 'Chat on Facebook Messenger',
    sublabel: 'm.me/doora',
    href: 'https://m.me/doora',
    iconVariantClassName: 'application-helper-option-icon-messenger',
    icon: (
      <svg width='22' height='22' viewBox='0 0 24 24' fill='none' aria-hidden='true'>
        <path
          d='M12 3c-5 0-9 3.7-9 8.4 0 2.5 1.2 4.7 3.1 6.2V21l2.9-1.6c1 .3 2 .4 3 .4 5 0 9-3.7 9-8.4S17 3 12 3z'
          stroke='currentColor'
          strokeWidth='1.8'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M7.5 13.2l3.2-3.4 2.2 1.7 3.6-2.5'
          stroke='currentColor'
          strokeWidth='1.8'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    ),
  },
  {
    label: 'Text us on WhatsApp',
    sublabel: '+61 400 000 000',
    href: 'https://wa.me/61400000000',
    iconVariantClassName: 'application-helper-option-icon-whatsapp',
    icon: (
      <svg width='22' height='22' viewBox='0 0 24 24' fill='none' aria-hidden='true'>
        <path
          d='M3.5 20.5l1.3-4.2A8.5 8.5 0 1 1 8 19.4l-4.5 1.1z'
          stroke='currentColor'
          strokeWidth='1.8'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M8.5 9.2c.2-.6.4-.7.7-.7h.6c.2 0 .5 0 .7.5l.7 1.7c.2.4 0 .6-.1.8l-.4.5c-.2.2-.3.4-.1.7.7 1.3 1.7 2.2 3 2.7.3.1.5.1.7-.1l.7-.7c.2-.2.4-.2.7-.1l1.6.8c.4.2.4.4.4.6 0 .3-.4 1-.9 1.4-.5.4-1.4.7-2.5.4-2-.5-4.4-2.7-5.2-4.7-.3-.8-.3-1.5-.1-2z'
          stroke='currentColor'
          strokeWidth='1.8'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    ),
  },
]

const DooraHelperModal: FC<DooraHelperModalProps> = ({onClose}) => {
  return (
    <ApplicationResponsiveModal
      ariaLabelledBy='application-helper-title'
      closeAriaLabel='Close helper options'
      onClose={onClose}
      modalClassName='application-helper-modal'
      closeButtonClassName='application-helper-modal-close'
      hideCloseButtonOnMobile
      mobileAnimationMs={380}
    >
      <h2 id='application-helper-title' className='application-helper-modal-title px-5 pt-5'>
        Message a Helper
      </h2>
      <p className='application-helper-modal-subtitle px-5'>
        A real person will get back to you, usually within a few hours.
      </p>

      <div className='application-helper-options'>
        {helperLinks.map((item) => (
          <a
            key={item.label}
            className='application-helper-option'
            href={item.href}
            target='_blank'
            rel='noopener noreferrer'
            aria-label={`${item.label} ${item.sublabel}`}
          >
            <span className={`application-helper-option-icon ${item.iconVariantClassName}`}>
              {item.icon}
            </span>

            <span className='application-helper-option-text'>
              <span className='application-helper-option-title'>{item.label}</span>
              <span className='application-helper-option-subtitle'>{item.sublabel}</span>
            </span>

            <i
              className='bi bi-chevron-right application-helper-option-chevron'
              aria-hidden='true'
            />
          </a>
        ))}
      </div>
    </ApplicationResponsiveModal>
  )
}

export default DooraHelperModal
